export const MODAL_ROUTE = {
    // Expenses
    CREATE_EXPENSE: 'create-expense',
    CREATE_EXPENSE_CATEGORY: 'create-expense-category',

    // Payments
    PURCHASE_PAYMENT: 'purchase-payment',

    // Products

    // Brands
    CREATE_PRODUCT_BRAND: 'create-product-brand',
    UPDATE_PRODUCT_BRAND: 'update-product-brand',

    CREATE_PRODUCT_TYPE: 'create-product-type',
    UPDATE_PRODUCT_TYPE: 'update-product-type',

    CREATE_PRODUCT_UNIT: 'create-product-unit',
    UPDATE_PRODUCT_UNIT: 'update-product-unit',
    CREATE_PRODUCT_GENERIC: 'create-product-generic',
    CREATE_PRODUCT_STRENGTH: 'create-product-strength',

    UPDATE_PRODUCT_INFO: 'update-product-info',

    // Suppliers
    CREATE_SUPPLIER: 'create-supplier',
    UPDATE_SUPPLIER: 'update-supplier',

    // Customers

    CREATE_CUSTOMER: 'create-customer',
    UPDATE_CUSTOMER: 'update-customer',

    // Payments
    MAKE_PAYMENT: 'make-payment',

    // Cart
    CART_SAVE_AS_DRAFT: 'save-as-draft',
    CART_CLEAR: 'clear-cart',
    CART_DRAFT_LIST: 'cart-draft-list',
    CART_SALES_RETURN: 'sales-rent',

    // Users
    CREATE_USER: 'create-user',

    // Invoice
    INVOICE_PURCHASE: 'purchase-invoice',
    INVOICE_ORDER: 'order-invoice',
} as const;
